// extracted by mini-css-extract-plugin
export var airports = "SearchAutoComplete-module--airports--3ccfe";
export var alt = "SearchAutoComplete-module--alt--3dc20";
export var cities = "SearchAutoComplete-module--cities--827a6";
export var clearSearch = "SearchAutoComplete-module--clearSearch--dfeb8";
export var container = "SearchAutoComplete-module--container--ec36d";
export var cruises = "SearchAutoComplete-module--cruises--380c9";
export var currentLocation = "SearchAutoComplete-module--currentLocation--37e4b";
export var desktopOnly = "SearchAutoComplete-module--desktopOnly--c2e0a";
export var emptyResults = "SearchAutoComplete-module--emptyResults--f018d";
export var hotels = "SearchAutoComplete-module--hotels--af2fb";
export var inputWrapper = "SearchAutoComplete-module--inputWrapper--5ebe9";
export var main = "SearchAutoComplete-module--main--e8bc2";
export var mobileOnly = "SearchAutoComplete-module--mobileOnly--86b85";
export var points = "SearchAutoComplete-module--points--c4b46";
export var searchResults = "SearchAutoComplete-module--searchResults--6187c";
export var sectionContainer = "SearchAutoComplete-module--sectionContainer--94ab1";
export var sectionTitle = "SearchAutoComplete-module--sectionTitle--f04a5";
export var sectionTitleText = "SearchAutoComplete-module--sectionTitleText--7daf7";
export var textLeft = "SearchAutoComplete-module--textLeft--a0d14";
export var truncateString = "SearchAutoComplete-module--truncateString--853cb";
export var visuallyHidden = "SearchAutoComplete-module--visuallyHidden--e91b7";
export var wrapper = "SearchAutoComplete-module--wrapper--fba93";